export default __webpack_public_path__ + "static/media/p50.8c697a9c.jpg";